import React, { Suspense } from 'react'

import { PageLoader } from 'component-library-next'
import { PersistGate } from 'redux-persist/integration/react'

import { ErrorBoundary } from '@app/App/ErrorBoundary'
import { logger } from '@app/common/logger/logger'
import { persistor } from '@app/common/store'
import { FeatureGate } from '@app/Feature'
import { AppRoot } from '@app/lib/context/AppRoot'
import { Router } from '@app/Router'

// styles
// TODO: Colocate these styles with the respective components
import 'normalize.css/normalize.css'
import './style.scss'

export function App() {
  return (
    <ErrorBoundary logger={logger}>
      <Suspense fallback={<PageLoader loading />}>
        <PersistGate loading={null} persistor={persistor}>
          <FeatureGate fallback={<PageLoader loading />}>
            <AppRoot>
              <Router />
            </AppRoot>
          </FeatureGate>
        </PersistGate>
      </Suspense>
    </ErrorBoundary>
  )
}
